<template>
  <div>
    <a-row :gutter="10">
      <a-col :md="6" :sm="24">
        <a-card :bordered="true">
          <div
            style="
              background: #fff;
              padding-left: 16px;
              height: 100%;
              margin-top: 5px;
            "
          >
            <a-input-search
              @search="onSearch"
              style="width: 100%; margin-top: 10px"
              placeholder="搜索班级"
            />
            <a-dropdown
              :trigger="[this.dropTrigger]"
              @visibleChange="dropStatus"
            >
              <span style="user-select: none">
                <!-- 树-->
                <!--组织机构-->
                <a-tree
                  showLine
                  :selectedKeys="selectedKeys"
                  :checkStrictly="true"
                  @rightClick="rightHandle"
                  @select="onSelect"
                  :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                  :treeData="departTree"
                  :autoExpandParent="autoExpandParent"
                  :expandedKeys="iExpandedKeys"
                  @expand="onExpand"
                />
              </span>
              <!--新增右键点击事件,和增加添加和删除功能-->
              <a-menu slot="overlay">
                <a-menu-item @click="handleRename" key="1">改名</a-menu-item>
                <a-menu-item @click="closeDrop" key="3">取消</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card :bordered="true">
          <a-tabs :activeKey="showTab" defaultActiveKey="2" @change="callback">
            <a-tab-pane tab="基本信息" key="1" forceRender>
              <Dept-Base-Info ref="DeptBaseInfo"></Dept-Base-Info>
            </a-tab-pane>
            <a-tab-pane tab="学生信息" key="2" forceRender>
              <Dept-User-Info
                ref="DeptUserInfo"
                @clearSelectedDepartKeys="clearSelectedDepartKeys"
              ></Dept-User-Info>
            </a-tab-pane>
            <a-tab-pane tab="作业" key="3" forceRender>
              <TeacherWorkList ref="TeacherWork" isInner/>
            </a-tab-pane>
            <!-- <a-tab-pane tab="课程信息" key="4" forceRender>
            <Dept-Course-Info ref="DeptCourseInfo"></Dept-Course-Info>
          </a-tab-pane> -->
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      :visible="renameDepartModalVisible"
      title="班级改名"
      @cancel="handleRenameCancel"
      @ok="handleRenameOk"
    >
      <a-form layout="inline">
        <a-form-item label="班级名" style="margin-left: 8px">
          <a-input
            placeholder="请输入班级名"
            v-model="formData.departName"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import DeptBaseInfo from "./modules/DeptBaseInfo";
import DeptUserInfo from "./modules/DeptUserInfo";
import TeacherWorkList from "./TeacherWorkList";
// import DeptCourseInfo from "./modules/DeptCourseInfo";
import { queryMyDepartTreeList, searchByKeywords } from "@/api/api";
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { httpAction } from "@/api/manage";

export default {
  name: "TeacherDepart",
  mixins: [JeecgListMixin],
  components: {
    DeptBaseInfo,
    DeptUserInfo,
    TeacherWorkList,
    // DeptCourseInfo,
  },
  data() {
    return {
      dropTrigger: "",
      renameDepartModalVisible: false,
      formData: {},
      currentDeptId: "",
      currentDept: {},
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: "",
      currFlowName: "",
      disable: true,
      treeData: [],
      visible: false,
      departTree: [],
      rightClickSelectedKey: "",
      hiding: true,
      model: {},
      dropTrigger: "",
      depart: {},
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      graphDatasource: {
        nodes: [],
        edges: [],
      },
      showTab: 2
    };
  },
  watch: {
    $route(to, from) {
      console.log(to);
      this.showTab = to.path.split("tab=")[1];
      console.log("tab:" + this.showTab);
    },
  },
  mounted() {
    this.showTab = location.href.split("tab=")[1];
  },
  created() {
    this.currFlowId = this.$route.params.id;
    this.currFlowName = this.$route.params.name;
    // this.loadTree()
  },
  methods: {
    // 右键操作方法
    rightHandle(node) {
      this.dropTrigger = "contextmenu";
      //   console.log(node.node.eventKey);
      //   this.rightClickSelectedKey = node.node.eventKey;
      // this.rightClickSelectedOrgCode = node.node.dataRef.orgCode

      this.formData.departName = node.node.dataRef.departName;
      this.formData.id = node.node.dataRef.id;
      //   console.log(node.node.dataRef);
    },
    // 右键点击下拉框改变事件
    dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = "";
      }
    },
    // 右键店家下拉关闭下拉框
    closeDrop() {
      this.dropTrigger = "";
    },
    handleRename() {
      this.renameDepartModalVisible = true;
      //   this.formData.id = this.rightClickSelectedKey
    },
    handleRenameCancel() {
      this.formData = {};
      this.renameDepartModalVisible = false;
    },
    handleRenameOk() {
      if (this.formData.id && this.formData.departName) {
        httpAction("/sys/sysDepart/edit", this.formData, "put").then((res) => {
          if (res.success) {
            this.$message.success("修改成功!");
            this.loadTree();
          } else {
            this.$message.error(res.message);
          }
          this.renameDepartModalVisible = false;
        });
      } else {
        this.$message.error("参数错误");
        return;
      }
    },
    callback(key) {
      this.showTab = key
    },
    loadData() {
      this.refresh();
    },
    hideTabs(idx) {
      this.$refs.tabs.$children[idx].$el.style.display = "none";
    },
    showTabs(idx) {
      this.$refs.tabs.$children[idx].$el.style.display = "none";
    },
    clearSelectedDepartKeys() {
      this.checkedKeys = [];
      this.selectedKeys = [];
      this.currentDeptId = "";
      this.currentDept = {};
      this.$refs.DeptUserInfo.currentDeptId = "";
      //   this.$refs.DeptCourseInfo.currentDeptId = "";
    },
    loadTree() {
      var that = this;
      that.treeData = [];
      that.departTree = [];
      queryMyDepartTreeList().then((res) => {
        if (res.success && res.result) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i];
            that.treeData.push(temp);
            that.departTree.push(temp);
            that.setThisExpandedKeys(temp);
            // console.log(temp.id)
          }
          this.loading = false;
        }
        that.userIdentity = res.message;
      });
    },
    setThisExpandedKeys(node) {
      //只展开一级目录
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);
        //下方代码放开注释则默认展开所有节点
        /**
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
          */
      }
    },
    refresh() {
      this.loading = true;
      this.loadTree();
    },

    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },

    onSearch(value) {
      let that = this;
      if (value) {
        searchByKeywords({ keyWord: value, myDeptSearch: "1" }).then((res) => {
          if (res.success) {
            that.departTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.departTree.push(temp);
            }
          } else {
            that.$message.warning(res.message);
          }
        });
      } else {
        that.loadTree();
      }
    },
    onCheck(checkedKeys, e) {
      let record = e.node.dataRef;
      // console.log('onCheck', checkedKeys, e);
      this.checkedKeys = [];
      // if (e.checked === true) {
      this.currentDeptId = record.id;
      this.currentDept = record;
      this.checkedKeys.push(record.id);

      this.$refs.DeptBaseInfo.open(record);
      this.$refs.DeptUserInfo.open(record);
      this.$refs.TeacherWork.open(record);

      //   this.$refs.DeptCourseInfo.open(record);
      // }
      // else {
      //   this.checkedKeys = [];
      //   this.$refs.DeptBaseInfo.clearForm();
      //   this.$refs.DeptUserInfo.clearList();
      // }

      this.hiding = false;
      // this.checkedKeys = checkedKeys.checked
    },
    onSelect(selectedKeys, e) {
      if (this.selectedKeys[0] !== selectedKeys[0]) {
        this.selectedKeys = [selectedKeys[0]];
      }
      let record = e.node.dataRef;
      this.currentDept = record;
      console.log(record);

      this.checkedKeys.push(record.id);
      this.$refs.DeptBaseInfo.open(record);
      this.$refs.DeptUserInfo.onClearSelected();
      this.$refs.DeptUserInfo.open(record);
      this.$refs.TeacherWork.open(record);

      //   this.$refs.DeptCourseInfo.onClearSelected();
      //   this.$refs.DeptCourseInfo.open(record);
    },
  },
};
</script>

<style>
</style>